import { useMemo } from 'react';
import { movies, type Movie } from '@/mocks/movies';
import { newsList } from '@/mocks/news';
import { useFavorites } from '@/hooks/useFavorites';
import { useToast } from '@/hooks/useToast';
import { usePageMeta } from '@/hooks/usePageMeta';
import Toast from '@/components/base/Toast';
import HeroSection from './components/HeroSection';
import FeaturedSlider from './components/FeaturedSlider';
import CategoryGrid from './components/CategoryGrid';
import LatestMovies from './components/LatestMovies';
import LatestNews from './components/LatestNews';
import IntroSection from './components/IntroSection';

const FEATURED_IDS = [16, 8, 11, 1];

export default function Home() {
  usePageMeta({
    title: '北条麻妃电影大全 - 专业影视作品资讯平台',
    description:
      '北条麻妃电影频道提供丰富的北条麻妃影视作品信息、剧情介绍及最新动态，满足影迷对相关电影的全面了解和作品查询需求。',
    keywords:
      '北条麻妃电影,北条麻妃影视作品,电影资讯,剧情介绍,影迷平台,最新电影,作品大全',
  });

  const { isFavorite, toggleFavorite } = useFavorites();
  const { toast, showToast } = useToast();

  const latestMovies = useMemo(
    () => [...movies].sort((a, b) => b.year - a.year).slice(0, 10),
    [],
  );

  const featured = useMemo(
    () => FEATURED_IDS.map((id) => movies.find((m) => m.id === id)).filter(Boolean) as Movie[],
    [],
  );

  const latestNews = useMemo(() => newsList.slice(0, 3), []);

  const handleToggleFavorite = (movie: Movie) => {
    const added = toggleFavorite(movie.id);
    showToast(added ? `已收藏《${movie.title}》` : `已取消收藏《${movie.title}》`, added ? 'accent' : 'default');
  };

  return (
    <>
      <HeroSection />
      <FeaturedSlider items={featured} />
      <CategoryGrid />
      <LatestMovies
        movies={latestMovies}
        isFavorite={isFavorite}
        onToggleFavorite={handleToggleFavorite}
      />
      <LatestNews items={latestNews} />
      <IntroSection />
      <Toast toast={toast} />
    </>
  );
}